export default __webpack_public_path__ + "static/media/explore-desktop-6.989db817.png";